export const courseEnrollmentPositionList = [
  {
    value: "Student of Computer Science or other similar degree",
    label: "Student of Computer Science or other similar degree",
  },
  {
    value: "IT Professionals looking for career change",
    label: "IT Professionals looking for career change",
  },
  {
    value: "IT Professionals (Up skill)",
    label: "IT Professionals (Up skill)",
  },
  {
    value: "IT Manager / Head",
    label: "IT Manager / Head",
  },
  {
    value: "Build your own team",
    label: "Build your own team",
  },
  { value: "Other", label: "Other" },
];

export const batchesList = [
  {
    value: "2 Months (Mon-Fri) 7 AM to 9 AM",
    label: "2 Months (Mon-Fri) 7 AM to 9 AM",
  },
];
